function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommitmentModalEventKey = exports.CommitmentModalContainer = void 0;
Object.defineProperty(exports, "CommitmentModalType", {
  enumerable: true,
  get: function get() {
    return _CommitmentModalType.CommitmentModalType;
  }
});
exports.ShowCommitmentModal = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _FullScreenDialog = require("../FullScreenDialog");
var _utils = require("../../utils");
var _reactNativeEventListeners = require("react-native-event-listeners");
var _CommitmentModalType = require("./CommitmentModalType");
var _DefaultModalContent = _interopRequireDefault(require("./DefaultModalContent"));
var _ExistingCheckModalContent = _interopRequireDefault(require("./ExistingCheckModalContent"));
var _SuccessfulLimitModalContent = _interopRequireDefault(require("./SuccessfulLimitModalContent"));
var _OrganizationShareModalContent = _interopRequireDefault(require("./OrganizationShareModalContent"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var CommitmentModalEventKey = exports.CommitmentModalEventKey = 'showCommitmentModalKey';
var ShowCommitmentModal = exports.ShowCommitmentModal = function ShowCommitmentModal(state) {
  _reactNativeEventListeners.EventRegister.emit(CommitmentModalEventKey, state);
};
var CommitmentModalContainer = exports.CommitmentModalContainer = (0, _react.memo)(function () {
  var _initialState = (0, _react.useMemo)(function () {
    return {
      modalType: _CommitmentModalType.CommitmentModalType.none,
      action: undefined,
      isHidden: true,
      isLoading: true,
      shareUrl: undefined
    };
  }, []);
  var _useState = (0, _react.useState)(_initialState),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _state = _useState2[0],
    _setState = _useState2[1];
  var _useStyles = (0, _styles.useStyles)({
      modalType: _state.modalType
    }),
    styles = _useStyles.styles;
  var _trackingSource = "CommitmentModal ".concat(_state.modalType);
  var _useAnalytics = (0, _utils.useAnalytics)(),
    trackEvent = _useAnalytics.trackEvent,
    trackingEvents = _useAnalytics.trackingEvents;
  var _closeModal = function _closeModal() {
    _setState(function (prevState) {
      return Object.assign({}, prevState, {
        isHidden: true
      });
    });
  };
  var _closeCallback = function _closeCallback() {
    var _state$action;
    trackEvent({
      eventName: trackingEvents.stepsUserFlow,
      props: {
        source: _trackingSource,
        type: 'close modal',
        'action param': (_state$action = _state.action) == null ? void 0 : _state$action.param
      }
    });
    _closeModal();
  };
  var _setIsLoading = (0, _react.useCallback)(function (isLoading) {
    _setState(function (prevState) {
      return Object.assign({}, prevState, {
        isLoading: isLoading
      });
    });
  }, []);
  var ModalContent = (0, _react.useMemo)(function () {
    var _state$action2, _state$action3, _state$action4, _state$action5, _state$action6, _state$action7, _state$action8, _state$action9;
    switch (_state.modalType) {
      case _CommitmentModalType.CommitmentModalType.pending:
        return (0, _jsxRuntime.jsx)(_DefaultModalContent["default"], {
          modalType: _CommitmentModalType.CommitmentModalType.pending,
          closeModal: _closeModal,
          actionId: (_state$action2 = _state.action) == null ? void 0 : _state$action2.id,
          actionParam: (_state$action3 = _state.action) == null ? void 0 : _state$action3.param,
          setIsLoading: _setIsLoading,
          trackingSource: _trackingSource
        });
      case _CommitmentModalType.CommitmentModalType.existing:
        return (0, _jsxRuntime.jsx)(_DefaultModalContent["default"], {
          modalType: _CommitmentModalType.CommitmentModalType.existing,
          closeModal: _closeModal,
          setIsLoading: _setIsLoading,
          trackingSource: _trackingSource,
          actionId: (_state$action4 = _state.action) == null ? void 0 : _state$action4.id,
          actionParam: (_state$action5 = _state.action) == null ? void 0 : _state$action5.param
        });
      case _CommitmentModalType.CommitmentModalType.complete:
        return (0, _jsxRuntime.jsx)(_DefaultModalContent["default"], {
          modalType: _CommitmentModalType.CommitmentModalType.complete,
          closeModal: _closeModal,
          setIsLoading: _setIsLoading,
          trackingSource: _trackingSource,
          actionId: (_state$action6 = _state.action) == null ? void 0 : _state$action6.id,
          actionParam: (_state$action7 = _state.action) == null ? void 0 : _state$action7.param
        });
      case _CommitmentModalType.CommitmentModalType.existingCheck:
        return (0, _jsxRuntime.jsx)(_ExistingCheckModalContent["default"], {
          action: _state.action,
          closeModal: _closeModal,
          trackingSource: _trackingSource,
          setIsLoading: _setIsLoading
        });
      case _CommitmentModalType.CommitmentModalType.successfulLimit:
        return (0, _jsxRuntime.jsx)(_SuccessfulLimitModalContent["default"], {
          closeModal: _closeModal,
          actionParam: (_state$action8 = _state.action) == null ? void 0 : _state$action8.param,
          trackingSource: _trackingSource,
          setIsLoading: _setIsLoading
        });
      case _CommitmentModalType.CommitmentModalType.organizationShare:
        return (0, _jsxRuntime.jsx)(_OrganizationShareModalContent["default"], {
          closeModal: _closeModal,
          actionParam: (_state$action9 = _state.action) == null ? void 0 : _state$action9.param,
          trackingSource: _trackingSource,
          setIsLoading: _setIsLoading,
          shareUrl: _state.shareUrl
        });
      default:
        return null;
    }
  }, [_setIsLoading, _state.action, _state.modalType, _state.shareUrl, _trackingSource]);
  (0, _react.useEffect)(function () {
    var _listener = _reactNativeEventListeners.EventRegister.addEventListener(CommitmentModalEventKey, function (newState) {
      _setState(function (prevState) {
        return Object.assign({}, prevState, {
          isHidden: false,
          isLoading: true
        }, newState);
      });
    });
    return function () {
      _reactNativeEventListeners.EventRegister.removeEventListener(_listener);
    };
  }, []);
  return (0, _jsxRuntime.jsx)(_FullScreenDialog.FullScreenDialog, {
    isHidden: _state.isHidden,
    closeCallback: _closeCallback,
    trackingLabel: _trackingSource,
    cardStyle: styles.modalCardStyle,
    isLoading: _state.isLoading,
    children: ModalContent
  });
});